<template>
    <div>
        <h4>{{labels[1496]}}</h4> <!-- label: Enter your purchase order information: -->
        <div class="row">
            <div class="col-xs-12 col-sm-5">
                <div class="marginbottom10">
                    <label for="poComment" class="control-label">{{labels[1497]}}</label> <!-- label: PO Number -->
                    <input class="payInfo form-control input-sm" type="text" name="poNumber" id="poNumber" v-model="po.number">
                </div>
                <div class="marginbottom10 checkbox">
                    {{labels[2466]}}<br> <!-- label: Authorized Purchaser -->
                    <label for="authorizedPurchaser" class="control-label">
                        <input type="checkbox" name="authorizedPurchaser" id="authorizedPurchaser" v-model="po.authorized">
                        <em class="small">
                            {{labels[2467]}} <!-- label: I am authorized to make purchases for my organization -->
                        </em>
                    </label>
                </div>
                <div class="marginbottom10 checkbox">
                    {{labels[2468]}}<br> <!-- Terms and Conditions -->
                    <label for="acceptTerms" class="control-label">
                        <input type="checkbox" name="acceptTerms" id="acceptTerms" v-model="po.terms">
                        <em class="small" v-html="labels[2469]"></em><!-- I accept <a href="/terms" target="_blank">Campbell Scientific's Terms and Conditions</a> -->
                    </label>
                </div>
            </div>
            <div class="col-xs-12 col-sm-5 marginbottom10">
                <div class="marginbottom10">
                    <label for="poComment" class="control-label">{{labels[1505]}}</label> <!-- label: Additional Information/comments -->
                    <textarea name="poComment" id="poComment" class="form-control input-sm payInfo" rows="3" v-model="po.comments"></textarea>
                </div>
                <div>
                    <label for="fobselect" class="control-label">{{labels[2498]}}</label>
                    <select name="fobselect" id="fobselect" class="form-control form-inline input-sm payInfo" v-model="po.fob">
                        <option v-for="(item,index) in labels[2497].split('^')" :key="index" :value="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import useBilling from "../composables/useBilling"
    import useCheckout from "../composables/useCheckout"
    import useCMS from "../../shared/composables/useCMS"
    import useUtils from "../../shared/composables/useUtils"
    import { watch, onMounted } from '@vue/composition-api'

    export default {
        name: 'BillingPurchaseorder',
        emits: ['billing-updated'],
        setup: function(props, {emit}){
            const { po, getCustomerCreditBalance, validPO } = useBilling();
            const { labels } = useCMS();
            const { toCurrency } = useUtils();
            const { pricing, reqPricing } = useCheckout();

            watch(validPO,(newVal) => {
                emit('billing-updated',newVal);
            });

            if(po.value.fob == '' && reqPricing.value == 'GSA'){
                po.value.fob = labels[2497].split('^')[1];
            } else if(po.value.fob == ''){
                po.value.fob = labels[2497].split('^')[0];
            }

            onMounted(() => {
                getCustomerCreditBalance();
                emit('billing-updated',validPO.value);
            })
            return {
                labels,
                po,
                toCurrency,
                pricing
            }
        }
    }
</script>
